const text = "_35st1sbsk5k";

export { text };
import "./atom.text.style.linaria.module.css";
//# sourceMappingURL=atom.text.style.js.map
